import { render, staticRenderFns } from "./NavigatorBar.vue?vue&type=template&id=0b77dc02&"
import script from "./NavigatorBar.vue?vue&type=script&lang=js&"
export * from "./NavigatorBar.vue?vue&type=script&lang=js&"
import style0 from "./NavigatorBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
installComponents(component, {VAppBar})
